/**
 * Expert validation report attachment.
 *
 * PDF only, so the document stays readable and printable as an official
 * record. The limit is mirrored server-side by multer.
 */
export const VALIDATION_REPORT_MAX_BYTES = 5 * 1024 * 1024;

export const VALIDATION_REPORT_MAX_LABEL = "5 Mo";

export const VALIDATION_REPORT_ACCEPTED_TYPES = ["application/pdf"];
